import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { SitiyRouter, PartnerRouter } from "./Router";
import { GlobalStyle } from './styles';
import { YMInitializer } from 'react-yandex-metrika';
import useDeviceInfo from "../hooks/useDeviceInfo";
import usePartner from "../hooks/usePartner";
import useAuthErrorHandler from "../hooks/useAuthErrorHandler";
import MainLayout from "./layouts/MainLayout";
import PartnerLayout from "./layouts/PartnerLayout";
import { getAppSettings, setDevMode, setIsCityModalOpen } from "../redux/reducer/slices/commonSlice";
import { getProfile } from "../redux/reducer/slices/profileSlice";
import { getCompanies } from "../redux/reducer/slices/companiesSlice";
import { getOrders } from "../redux/reducer/slices/ordersSlice";
import { ScrollProvider } from "../hooks/ScrollContext";
import DevTools from "../components/DevTools";
import useAppVersion from '../hooks/useAppVersion.js';
import { useInactivity } from "../hooks/useInactivity";

const App = () => {
    useDeviceInfo();
    usePartner();
    useAuthErrorHandler(); // Добавляем хук для обработки ошибок авторизации
    const location = useLocation();
    const dispatch = useDispatch();
    const { device, orientation, isDevMode, currentCity } = useSelector((state) => state.common);
    const { isAuth } = useSelector((state) => state.profile);
    const { currentPartner } = useSelector((state) => state.partner);
    const { version: appVersion, updateIndicator } = useAppVersion(); // Должен быть первым для проверки версии
    const { inactivity } = useInactivity();

    const { products } = useSelector((state) => state.cart);
    console.log('inactivity', inactivity);
    console.log('products', products);

    if (device === 'mobile' && orientation === 'portrait') {
        const setVh = () => {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };
        
        window.addEventListener('resize', setVh);
        setVh();
    }

    useEffect(() => {
        dispatch(getAppSettings());

        if (!currentCity &&
            location.pathname !== '/app' &&
            !location.pathname.includes('/kitchens')
        ) {
            dispatch(setIsCityModalOpen());
        }

        if (isAuth) {
            dispatch(getProfile());
            dispatch(getCompanies());
            dispatch(getOrders());
        }
    }, [isAuth]);

    useEffect(() => {
        const dev = (enable = true) => {
            dispatch(setDevMode(enable));
            localStorage.setItem('isDevMode', enable);
            console.log(`Dev mode ${enable ? '✅ enabled' : '❌ disabled'}`);
            return enable;
        };
    
        window.dev = dev;
    
        return () => {
            delete window.enableDevMode;
        };
    }, [dispatch]);

    return (
        <>
            <GlobalStyle/>
            <YMInitializer
                accounts={[50456719, 104716907]} // Отдельный счетчик для партнера Столовкин Пенза
                options={{
                    clickmap: true,
                    trackLinks: true,
                    accurateTrackBounce: true,
                    webvisor: true,
                }}
                version="2"
            />

            <ScrollProvider>
                {currentPartner ? (
                    <PartnerLayout>
                        <PartnerRouter/>
                    </PartnerLayout>
                ) : (
                    <MainLayout>
                        <SitiyRouter/>
                    </MainLayout>
                )}
            </ScrollProvider>

            {isDevMode && <DevTools/>}

            {updateIndicator}
        </>
    );
};

export default App;
